var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSharing = function SvgIconSharing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-sharing_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.654 16.842H3.346a2.294 2.294 0 0 1-2.293-2.293V5.625a2.294 2.294 0 0 1 2.293-2.293H5.21c.344 0 .625.282.625.625a.627.627 0 0 1-.625.625H3.346c-.575 0-1.043.47-1.043 1.043v8.924c0 .575.468 1.043 1.043 1.043h13.312c.575 0 1.043-.468 1.043-1.043v-2.871c0-.344.282-.625.625-.625.344 0 .625.281.625.625v2.871a2.3 2.3 0 0 1-2.297 2.293Z",
    fill: "#44494D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.324 13.512a.62.62 0 0 1-.625-.613v-1.25c0-4.481 3.644-8.126 8.125-8.126h.207V.813a.625.625 0 0 1 1.074-.43l5.418 5.625a.623.623 0 0 1 0 .867L14.105 12.5a.623.623 0 0 1-1.074-.43V9.363h-.988a6.837 6.837 0 0 0-6.149 3.8.66.66 0 0 1-.57.349Zm7.5-8.743c-3.5 0-6.399 2.63-6.824 6.016a8.075 8.075 0 0 1 6.039-2.684h1.613c.344 0 .625.282.625.625v1.786l3.93-4.075-3.926-4.074v1.785a.627.627 0 0 1-.625.625h-.832V4.77Z",
    fill: "#44494D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.654 16.842H3.346a2.294 2.294 0 0 1-2.293-2.293V5.625a2.294 2.294 0 0 1 2.293-2.293H5.21c.344 0 .625.282.625.625a.627.627 0 0 1-.625.625H3.346c-.575 0-1.043.47-1.043 1.043v8.924c0 .575.468 1.043 1.043 1.043h13.312c.575 0 1.043-.468 1.043-1.043v-2.871c0-.344.282-.625.625-.625.344 0 .625.281.625.625v2.871a2.3 2.3 0 0 1-2.297 2.293Z",
    stroke: "#44494D",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.324 13.512a.62.62 0 0 1-.625-.613v-1.25c0-4.481 3.644-8.126 8.125-8.126h.207V.813a.625.625 0 0 1 1.074-.43l5.418 5.625a.623.623 0 0 1 0 .867L14.105 12.5a.623.623 0 0 1-1.074-.43V9.363h-.988a6.837 6.837 0 0 0-6.149 3.8.66.66 0 0 1-.57.349Zm7.5-8.743c-3.5 0-6.399 2.63-6.824 6.016a8.075 8.075 0 0 1 6.039-2.684h1.613c.344 0 .625.282.625.625v1.786l3.93-4.075-3.926-4.074v1.785a.627.627 0 0 1-.625.625h-.832V4.77Z",
    stroke: "#44494D",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    y: 17.895,
    width: 20,
    height: 1.579,
    rx: 0.789,
    fill: "#44494D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-sharing_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgIconSharing;